<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>

<script>
import { defineComponent } from 'vue'
  import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

export default defineComponent({
  components: { ElConfigProvider },
  setup() {
    return {
      locale: zhCn,
    }
  }
})
</script>


<style lang="scss">
html,body{
  height: 100%;
  margin: 0px;
}

#app {
  font-family: 'Microsoft YaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #666666;
  height: 100%;
  font-size: 14px;
}

@import "@/assets/css/index.scss";  
</style>